import { createReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

// Default table query state.
export const defaultTableQueryState = {
  pageSize: 20,
  pageIndex: 0,
  inactiveMode: false,
  filterRoles: [],
  viewSlug: null,
};

// initial data.
const initialState = {
  tableState: defaultTableQueryState,
  selectedRows: [],
};

const reducerInstance = createReducer(initialState, (builder) => {
  Object.entries(
    createTableStateReducers('CUSTOMERS', defaultTableQueryState),
  ).forEach(([actionType, reducer]) => {
    builder.addCase(actionType, reducer);
  });

  builder.addCase('CUSTOMERS/SET_SELECTED_ROWS', (state, action: any) => {
    state.selectedRows = action.payload;
  });

  builder.addCase('CUSTOMERS/RESET_SELECTED_ROWS', (state) => {
    state.selectedRows = [];
  });

  builder.addCase(t.RESET, () => initialState);
});

const STORAGE_KEY = 'leyona:estimates';

export default persistReducer(
  {
    key: STORAGE_KEY,
    whitelist: [],
    storage,
  },
  reducerInstance,
);
